import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import Swal from 'sweetalert2';
import { IModalActiveResponse } from '../interfaces/modal-active.interface';

@Injectable()
export class ModalActiveService {
  private callBackSubject = new Subject<IModalActiveResponse>();
  callBack$: Observable<IModalActiveResponse> = this.callBackSubject.asObservable();

  openModalActive(title: string, confirmButtonText = 'Save', cancelButtonText = 'Cancel' ): void {
    Swal({
      title,
      input: 'text',
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      allowOutsideClick: true,
      onOpen: () => {
        Swal.disableConfirmButton();
        const input = Swal.getInput();
        if (input) {
          input.onkeyup = function (event: KeyboardEvent) {
            const target = event.target as HTMLInputElement;
            if (target && target.value) {
              if (target.value.trim() === '') {
                Swal.disableConfirmButton();
              } else {
                Swal.enableConfirmButton();
              }
            } else {
              Swal.disableConfirmButton();
            }
          };
        }
      }
    }).then(res => {
        if (res.value) {
          this.callBackSubject.next({ value: res.value, cancel: false });
        } else {
          if (res.dismiss) {
            this.callBackSubject.next({ value: null, cancel: true });
          }
        }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/modalActive.service.ts